module.exports = __webpack_public_path__ + "static/media/liderazgo-AUTOAGENCIA.adfa95f6.svg";